<template>
    <div>
        <div style="padding:5px 0 5px 10px; background:#f2f2f2">
            <h2 class="van-doc-demo-block__title" style="font-weight:normal; font-size:18px">Nakliye kim tarafından ayarlanacak ?</h2>
            <van-radio-group v-model="nakliye.s1" direction="horizontal" style="margin-top:25px; margin-bottom:25px">
                <van-radio style="font-size: 19px; margin-right: 40px;" name="Müşteri">Müşteri</van-radio>
                <van-radio style="font-size: 19px; margin-right: 40px;" name="AS">AS</van-radio>
            </van-radio-group>            
        </div>

        <div style="padding:0px 0 0px 10px;background:#fff">
            <h2 class="van-doc-demo-block__title" style="font-weight:normal; font-size:18px">Müşteri Lojistik tarafından aranacak mı?</h2>
            <van-radio-group v-model="nakliye.s2" direction="horizontal" style="margin-top:25px; margin-bottom:25px">
                <van-radio style="font-size: 19px; margin-right: 40px;" name="Evet">Evet</van-radio>
                <van-radio style="font-size: 19px; margin-right: 40px;" name="Hayır">Hayır</van-radio>
            </van-radio-group>            
        </div>
        <div style="padding:1px 0 1px 10px; background:#f2f2f2">
            <h2 class="van-doc-demo-block__title" style="font-weight:normal; font-size:18px">Nakliye fiyat onayı müşteriden alınacak mı ?</h2>
            <van-radio-group v-model="nakliye.s3" direction="horizontal" style="margin-top:25px; margin-bottom:25px">
                <van-radio style="font-size: 19px; margin-right: 40px;" name="Evet">Evet</van-radio>
                <van-radio style="font-size: 19px; margin-right: 40px;" name="Hayır">Hayır</van-radio>
            </van-radio-group>            
        </div>
        <div style="padding:0px 0 0px 10px">
            <h2 class="van-doc-demo-block__title" style="font-weight:normal; font-size:18px">Nakliye bedeli faturadan düşülecek mi ?</h2>
            <van-radio-group v-model="nakliye.s5" direction="horizontal" style="margin-top:25px; margin-bottom:25px">
                <van-radio style="font-size: 19px; margin-right: 40px;" name="Evet">Evet</van-radio>
                <van-radio style="font-size: 19px; margin-right: 40px;" name="Hayır">Hayır</van-radio>
            </van-radio-group>            
        </div>
        <div style="padding:1px 0 1px 10px; background:#f2f2f2">
            <h2 class="van-doc-demo-block__title" style="font-weight:normal; font-size:18px">Nakliye ödemesini kim yapacak ?</h2>
            <van-radio-group v-model="nakliye.s6" direction="horizontal" style="margin-top:25px; margin-bottom:25px">
                <van-radio style="font-size: 19px; margin-right: 40px;" name="Müşteri">Müşteri</van-radio>
                <van-radio style="font-size: 19px; margin-right: 40px;" name="AS">AS</van-radio>
            </van-radio-group>            
        </div>
        <div style="padding:0px 0 0px 10px">
            <h2 class="van-doc-demo-block__title" style="font-weight:normal; font-size:18px">Ürün çıkışı için muhasebeden onay ? </h2>
            <van-radio-group v-model="nakliye.s7" direction="horizontal" style="margin-top:25px; margin-bottom:25px">
                <van-radio style="font-size: 19px; margin-right: 40px;" name="Evet">Evet</van-radio>
                <van-radio style="font-size: 19px; margin-right: 40px;" name="Hayır">Hayır</van-radio>
            </van-radio-group>            
        </div>       
        <div style="padding:0px 0 0px 10px;">
            <van-field v-model="nakliye.s4" label="Nakliye" placeholder="Kişi, telefon" />

        </div>  
        <div style="padding:0px 0 0px 10px;">
            <van-field v-model="nakliye.odeme" label="Ödeme" placeholder="Ödeme Şekli" />

        </div> 
        <div style="padding:0px 0 0px 10px;">
            <van-field
                v-model="nakliye.not"
                label="Not"
                type="textarea"
                placeholder="Açıklama"
                rows="2"
                autosize
            /> 
        </div> 
               
      <van-button type="danger" style="margin:5px auto" block size="large" > SİPARİŞİ TAMAMLA </van-button>
      
    </div>
</template>

<script>
export default {
  components:{},
  data() {
    return {
        nakliye: {
            s1:"Müşteri",
            s2:"Evet",
            s3:"Evet",
            s5:"Evet",
            s6:"Müşteri",
            s7:"Evet",
            s4:"",
            ödeme:""





        }
    };
  },
  created (){
    this.$store.commit("setLoading",[false,'...'])    
  },

  methods : {

  }
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/sonuc.vue